const TOPICS = [
  { label: '韩漫推荐', hot: true, icon: 'ri-fire-fill', color: 'text-primary-600 bg-primary-100' },
  { label: '日漫精选', hot: true, icon: 'ri-sun-fill', color: 'text-accent-600 bg-accent-100' },
  { label: '国漫崛起', hot: true, icon: 'ri-rocket-fill', color: 'text-secondary-600 bg-secondary-100' },
  { label: '恋爱漫画', hot: false, icon: 'ri-heart-fill', color: 'text-pink-600 bg-pink-100' },
  { label: '奇幻冒险', hot: true, icon: 'ri-compass-fill', color: 'text-amber-600 bg-amber-100' },
  { label: '悬疑推理', hot: false, icon: 'ri-search-eye-line', color: 'text-indigo-600 bg-indigo-100' },
  { label: '搞笑日常', hot: false, icon: 'ri-emotion-laugh-fill', color: 'text-green-600 bg-green-100' },
  { label: 'BL漫画', hot: true, icon: 'ri-star-fill', color: 'text-rose-600 bg-rose-100' },
  { label: '热血少年', hot: false, icon: 'ri-flashlight-fill', color: 'text-orange-600 bg-orange-100' },
  { label: '都市言情', hot: false, icon: 'ri-building-2-fill', color: 'text-cyan-600 bg-cyan-100' },
  { label: '恐怖灵异', hot: false, icon: 'ri-ghost-fill', color: 'text-purple-600 bg-purple-100' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            发现当下最火的<strong>免费漫画</strong>话题，找到属于你的阅读方向
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {TOPICS.map((topic) => (
            <a
              key={topic.label}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer hover:scale-105 ${topic.color}`}
            >
              <i className={`${topic.icon} text-xs`}></i>
              <span>{topic.label}</span>
              {topic.hot && (
                <span className="px-1.5 py-0.5 text-[10px] font-bold bg-primary-500 text-background-50 rounded-full leading-none">
                  HOT
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}